

import React, { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import createAxiosInstance from "../../../../utils/axiosInstance";
import { API_ENDPOINTS } from '../../../../utils/api';
import dayjs from 'dayjs';
import useMyAgencyData from '../../../../hooks/useMyAgencyData';
import { userRoleMap } from '../../../../utils/helper';
import useUserData from '../../../../hooks/useUserData';
import Loader from '../../../../Components/Loader';
import { formatDateTime } from '../../../../utils/formatters';

const UserDetails = () => {
  const myShelter = useMyAgencyData();
  const me = useUserData();
  const axiosInstance = createAxiosInstance();
  const { userId } = useParams();
  const [user, setUserDetails] = useState<any>({});
  const [userActive, setUserActive] = useState(false);
  const [isLoding, setIsLoding] = useState(true);

  useEffect(() => {
    if (myShelter) {
      getUserDetails();
    }
  }, [myShelter]);

  const getUserDetails = async () => {
    try {
      const response = await axiosInstance.get(`${API_ENDPOINTS.BEDFINDER.GETUSERS}/${userId}`);

      const data = response.data; // Extract the actual data

      setUserDetails(data);
      setUserActive(data.active);
      setIsLoding(false);
    } catch (error) {
      setIsLoding(false);
      console.log(error);
    }
  };

  const handleUserStatus = async () => {
    try {
      setIsLoding(true);
      const data = {
        active: !userActive
      }
      const response = await axiosInstance.put(`${API_ENDPOINTS.BEDFINDER.GETUSERS}/${userId}`, data);
      if (response.status === 200) {
        setUserActive(!userActive);
        getUserDetails();
        setIsLoding(false);
      }
    } catch (error) {
      setIsLoding(false);
      console.log(error);
    }
  }

  return (
    <>
      {isLoding && <Loader />}
      <div className="container py-4 md:py-10 2xl:py-[70px] flex justify-center">
        <div className="w-full xl:w-2/3">
          <div className="card mt-5 p-4 md:p-6">
            <h2 className='text-base lg:text-lg 2xl:text-2xl font-semibold'>{`${user?.firstName} ${user?.lastName}`}</h2>
            <div className="border border-borderGray rounded-xl overflow-hidden mt-5">
              <table className="w-full text-xs 2xl:text-sm text-left rtl:text-right text-gray-500">
                <tbody>
                  <tr className="bg-white md:border md:border-b-borderGray">
                    <th scope="row" className="px-4 2xl:px-6 py-3 font-medium text-gray-900 border md:border-r-borderGray md:border-b-borderGray md:text-right">
                      Date Connected
                    </th>
                    <td className="px-4 2xl:px-6 py-3 md:text-left md:w-4/6 text-gray-700">
                      {formatDateTime(user.createdAt)}
                    </td>
                  </tr>
                  <tr className="bg-white md:border md:border-b-borderGray">
                    <th scope="row" className="px-4 2xl:px-6 py-3 font-medium text-gray-900 border md:border-r-borderGray md:border-b-borderGray md:text-right">
                      Email
                    </th>
                    <td className="px-4 2xl:px-6 py-3 md:text-left md:w-4/6 text-gray-700">
                      <Link className='text-primary' to={`mailto:${user?.email}`}>{user?.email}</Link>
                    </td>
                  </tr>
                  <tr className="bg-white md:border md:border-b-borderGray">
                    <th scope="row" className="px-4 2xl:px-6 py-3 font-medium text-gray-900 border md:border-r-borderGray md:border-b-borderGray md:text-right">
                      Shelter
                    </th>
                    <td className="px-4 2xl:px-6 py-3 md:text-left md:w-4/6 text-gray-700">
                      {myShelter?.name}
                    </td>
                  </tr>
                  <tr className="bg-white md:border md:border-b-borderGray">
                    <th scope="row" className="px-4 2xl:px-6 py-3 font-medium text-gray-900 border md:border-r-borderGray md:border-b-borderGray md:text-right">
                      Role
                    </th>
                    <td className="px-4 2xl:px-6 py-3 md:text-left md:w-4/6 text-gray-700">
                      {userRoleMap[user?.roles?.[0] as keyof typeof userRoleMap]}
                    </td>
                  </tr>
                  <tr className="bg-white md:border md:border-b-borderGray">
                    <th scope="row" className="px-4 2xl:px-6 py-3 font-medium text-gray-900 border md:border-r-borderGray md:border-b-borderGray md:text-right">
                      Status
                    </th>
                    <td className="px-4 2xl:px-6 py-3 md:text-left md:w-4/6 text-gray-700">
                      <label className="inline-flex items-center cursor-pointer">
                        {me?.roles[0] === "admin" && me?.id !== user.id && (<input type="checkbox" checked={userActive} value="" className="sr-only peer" onChange={handleUserStatus} />)}
                        <span className="text-sm font-medium text-gray-600 me-2">{userActive ? "Active" : "Inactive"}</span>
                        {me?.roles[0] === "admin" && me?.id !== user.id && (<div className="relative w-9 h-5 bg-gray-200 rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:bg-orange-500"></div>)}
                      </label>
                    </td>
                  </tr>
                  <tr className="bg-white md:border md:border-b-borderGray">
                    <th scope="row" className="px-4 2xl:px-6 py-3 font-medium text-gray-900 border md:border-r-borderGray md:border-b-borderGray md:text-right">
                      Last login date
                    </th>
                    <td className="px-4 2xl:px-6 py-3 md:text-left md:w-4/6 text-gray-700">
                      {user.lastLogin ? formatDateTime(user.lastLogin) : "-"}
                    </td>
                  </tr>
                  <tr className="bg-white md:border md:border-b-borderGray">
                    <th scope="row" className="px-4 2xl:px-6 py-3 font-medium text-gray-900 border md:border-r-borderGray md:border-b-borderGray md:text-right">
                      Last modified date
                    </th>
                    <td className="px-4 2xl:px-6 py-3 md:text-left md:w-4/6 text-gray-700">
                      {user.lastLoginDate ? formatDateTime(user.lastLoginDate) : "-"}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <button>
              <Link to={`/my-account`}
                className="btn btn-outline-gray py-2 2xl:py-3 mt-4"
              >
                Go Back
              </Link>
            </button>
          </div>
        </div>
      </div>
    </>
  )
}

export default UserDetails